import React from 'react';
import PropTypes from 'prop-types';
import './Button.scss';

/**
 * @description Button
 *
 * @returns {<Button />}
 */
const Button = ({ label, handleClick }) => (
  <button className="tsla-btn tsla-btn--blue tsla-btn--small btn-full" onClick={handleClick}>
    {label}
  </button>
);

Button.propTypes = {
  label: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default Button;
